/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/PostFilter/Signed/Active
 * @desc Active filter component for signed
 */

import { isActive } from 'labstep-web/components/Filter/List/utils';
import { EXPERIMENT_WORKFLOW_POST_FILTER_URL_PARAMETERS } from 'labstep-web/constants/post-filter';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { SignedTypes } from 'labstep-web/models/experiment-workflow.model';
import { LocationService } from 'labstep-web/services/location.service';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { ExperimentWorkflowPostFilterSignedActiveProps } from './types';

const ExperimentWorkflowPostFilterSignedActive: React.FC<
  ExperimentWorkflowPostFilterSignedActiveProps
> = ({ searchParams, location, history }) => {
  const activeSignedType = Object.values(SignedTypes).find((value) =>
    isActive(searchParams, value.params),
  );

  if (searchParams.signature_request_user_id !== undefined) {
    return (
      <RemoveLabel
        icon="edit"
        name="For me to sign"
        onRemoveClick={() => {
          LocationService.removeQueryParameters(
            history,
            location,
            EXPERIMENT_WORKFLOW_POST_FILTER_URL_PARAMETERS,
          );
        }}
      />
    );
  }

  if (activeSignedType) {
    return (
      <RemoveLabel
        icon={activeSignedType.icon}
        name={activeSignedType.text}
        onRemoveClick={() => {
          LocationService.removeQueryParameters(
            history,
            location,
            EXPERIMENT_WORKFLOW_POST_FILTER_URL_PARAMETERS,
          );
        }}
      />
    );
  }

  return null;
};

export default withRouter(ExperimentWorkflowPostFilterSignedActive);
